import type { PaymentItemProps } from '@/types';
import { Card, Group, Image, Radio, Stack, Text } from '@mantine/core';
export const PaymentItem: React.FC<PaymentItemProps> = ({
  checked,
  value,
  handleClick,
  paymentName,
  endCode
}) => {
  return <Card radius={5} bg="var(--bg-400)" p={12}>
      <Group justify="space-between">
        <Group>
          <Radio color="var(--text-prime)" variant="outline" value={value} checked={checked} onChange={handleClick} />
          <Stack gap={0}>
            <Text fz="xs" tt="uppercase" c="var(--text-dark)">
              {`${paymentName} ending in ${endCode}`}
            </Text>
            <Text fz="xs" c="var(--text-grey-2)">
              {'Expires 07/28'}
            </Text>
          </Stack>
        </Group>
        <Image src="/assets/wallet/visa.png" alt="visa" w={54} h={18} />
      </Group>
    </Card>;
};